<div class="max-w-4xl mx-auto py-10 px-6 md:px-8">
    <!-- Header Section -->
    <div class="text-center mb-10">
        <h1 class="text-3xl font-bold text-primary mb-2">Return & Exchange Policy</h1>
        <p class="text-lg">At Mashhoor Plus, we are committed to providing you with high-quality herbal products that support your well-being. Your satisfaction is our priority.</p>
    </div>

    <!-- Table of Contents -->
    <!-- <div class="bg-gray-50 p-6 rounded-lg mb-10 shadow-sm">
        <h2 class="text-xl font-semibold mb-4">Quick Navigation</h2>
        <ul class="space-y-2">
            <li><a href="#order-cancellation" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Order Cancellation Policy</a></li>
            <li><a href="#return-exchange" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Return/Exchange Policy and Procedure</a></li>
            <li><a href="#guidelines" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Important Return Guidelines</a></li>
            <li><a href="#exclusions" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Exclusions for Return/Exchange</a></li>
            <li><a href="#faq" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Frequently Asked Questions</a></li>
        </ul>
    </div> -->

    <!-- Order Cancellation Policy -->
    <section id="order-cancellation" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Order Cancellation Policy</h2>
        </div>
        <div class="space-y-4">
            <p>Orders once placed on our official website <a href="https://www.mashhoorplus.in" class="text-primary hover:underline">www.mashhoorplus.in</a> are not eligible for cancellation. However, in exceptional circumstances:</p>
            
            <ul class="list-disc pl-6 space-y-3">
                <li>If a cancellation request is made within 24 hours of placing the order and before dispatch, we may accept the request at our discretion.</li>
                <li>If the order has already been processed or dispatched within that 24-hour window, cancellation will be possible only after deduction of applicable shipping or statutory charges.</li>
                <li>Once 24 hours have passed since the order was placed, no cancellation will be entertained.</li>
                <li>A refund can take up to 15 working days from the time the refund request has been approved. A customer will be informed about the refund via WhatsApp.</li>
            </ul>
            
            <div class="bg-gray-50 p-4 rounded-md">
                <p class="font-medium">Please Note:</p>
                <ul class="list-disc pl-6 mt-2">
                    <li>Mashhoor Plus may need to cancel certain orders that are either outside our delivery service area or logistically difficult to ship.</li>
                    <li>We reserve the full right to refuse, cancel, or deny any order at our sole discretion, without prior notice, for any reason deemed necessary.</li>
                    <li>Mashhoor Plus reserves the right to cancel orders due to product quantity limitations, inaccuracies or errors in product or pricing information, or issues identified by our credit and fraud prevention team.</li>
                    <li>If any transaction appears to be fraudulent or violates the terms and conditions of using our website, Mashhoor Plus, at its sole discretion, may cancel such orders with or without prior notice.</li>
                    <li>Mashhoor Plus reserves the right to request proof of identification from the customer at the time of delivery. Failure to provide valid identification may result in cancellation of the order.</li>
                </ul>
            </div>
        </div>
    </section>

    <!-- Return/Exchange Policy Section -->
    <section id="return-exchange" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Return/Exchange Policy and Procedure</h2>
        </div>
        
        <div class="mb-6">
            <h3 class="text-xl font-semibold mb-3">Damaged or Incorrect Product Delivery</h3>
            <p>If a product is damaged during delivery to the customer or if the wrong product is delivered for any reason, it is essential for the buyer to contact Mashhoor Plus immediately and inform our customer service team about the issue.</p>
            <div class="bg-gray-50 p-4 rounded-md mt-3">
                <p class="font-medium">Contact Options:</p>
                <ul class="mt-2">
                    <li>Call our helpline: <span class="font-semibold">+91 8273363610</span> (10am-6pm IST)</li>
                    <li>Email us: <a href="mailto:mashhoorplus&#64;gmail.com" class="text-primary hover:underline">mashhoorplus&#64;gmail.com</a></li>
                </ul>
                <p class="mt-2 text-sm italic">We highly recommend customers take pictures or record a video while opening the product packaging.</p>
            </div>
        </div>
        
        <div class="mb-6">
            <h3 class="text-xl font-semibold mb-3">Time Frame for Reporting Issues</h3>
            <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4">
                <p>It is imperative and mandatory for each customer to inform the company about the damaged or incorrect product within <span class="font-bold">24 hours</span> from the time the product has been delivered. Failure to do so will result in no return or exchange being entertained.</p>
            </div>
        </div>
        
        <div class="mb-6">
            <h3 class="text-xl font-semibold mb-3">Return Process</h3>
            <p class="font-medium">We do not accept returns that are sent to us directly. You must lodge a return/exchange request to receive a return/exchange ticket, and the return or exchange will be processed accordingly.</p>
            
            <div class="mt-4 border border-gray-200 rounded-lg overflow-hidden">
                <div class="bg-gray-100 p-3">
                    <h4 class="font-semibold">Procedure for Return/Exchange</h4>
                </div>
                <div class="p-4">
                    <ol class="list-decimal pl-6 space-y-3">
                        <li>Upon receiving your return/exchange request, customer care will contact you and inquire about the preliminary information regarding the damage or incorrect product delivered. This may include:
                            <ul class="list-disc pl-6 mt-2">
                                <li>Damaged Product Images</li>
                                <li>Wrong Product Delivered Images</li>
                                <li>Packaging Images</li>
                                <li>Any other information as may be required</li>
                            </ul>
                        </li>
                        <li>After reviewing the details provided, our customer care will inform you whether the return/exchange request can be processed.</li>
                        <li>Please mail your shipment details the day you dispatch the damaged or wrong product.</li>
                        <li>If the return/exchange request is accepted, it will be forwarded to the concerned team, and you will be asked to send the product for physical verification.</li>
                        <li>Once the product is received and verified, the status of your return/exchange will be communicated within 24 hours.</li>
                        <li>Replacement of the product may take up to 15 days from the date the damaged product is received by us.</li>
                    </ol>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Important Guidelines Section -->
    <section id="guidelines" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Important Return Guidelines</h2>
        </div>
        <ul class="list-disc pl-6 space-y-3">
            <li>The product must be returned in its original packaging box.</li>
            <li>The product serial number must remain untampered.</li>
            <li>The product composition should remain unaltered.</li>
            <li>The label, cartons, and other packaging materials should be returned with the product.</li>
            <li>If a free gift was included as part of the order, it should also be returned with the original packaging, seals, labels, and barcodes intact.</li>
            <li>In cases where the defects or claims made by the customer are found to be false or without merit, the claims will be rejected, and all shipping charges will be debited to the customer, with the product returned accordingly.</li>
        </ul>
    </section>
    
    <!-- Exclusions Section -->
    <section id="exclusions" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Exclusions for Return/Exchange</h2>
        </div>
        <ul class="list-disc pl-6 space-y-3">
            <li>No return/exchange will be provided for free products.</li>
            <li>No return/exchange will be accepted if the customer refuses delivery or if adequate delivery attempts have been made by our delivery partners, but remain unsuccessful.</li>
            <li>No return/exchange will be accepted if the customer was unavailable during the scheduled delivery attempts or if the provided address was incorrect.</li>
            <li>Mashhoor Plus will not be held responsible for any damage caused after the product is delivered, and no return/exchange will be provided in such cases.</li>
        </ul>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">Refund Requests</h3>
            <p>We do not entertain refund-related requests where an exchange is possible.</p>
        </div>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">Company's Discretion on Return/Exchange</h3>
            <p>Please note that the return/exchange of products is at the sole discretion of the company and will depend on the specific case. Mashhoor Plus reserves the exclusive right to decide whether a return/exchange will be entertained.</p>
        </div>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">Notification of Changes to the Policy</h3>
            <p>We review our Cancellation, Returns, and Refunds Policy regularly to ensure it is up to date. Any changes we make to this policy in the future will be posted on this page. We reserve the right to update or change this policy at any time without prior notice. Such changes will be effective immediately upon posting on our website. We recommend that you review the policy regularly to stay informed of any changes.</p>
        </div>
    </section>
    
    <!-- FAQ Section -->
    <section id="faq" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Frequently Asked Questions</h2>
        </div>
        
        <div class="space-y-6">
            <div class="bg-gray-50 p-5 rounded-lg">
                <h3 class="text-lg font-semibold mb-2">Shipping and Delivery</h3>
                
                <div class="space-y-4 mt-4">
                    <div>
                        <p class="font-medium">Q: How does the delivery process work?</p>
                        <p class="mt-1">All our deliveries are serviced through well-reputed couriers. As soon as your order is dispatched, you will receive an email with your package's tracking number as well as the name of the courier company that is processing your order. You can use the tracking number to track the status of your package on the courier company's website.</p>
                    </div>
                    
                    <div>
                        <p class="font-medium">Q: Which locations are covered under your delivery service?</p>
                        <p class="mt-1">We deliver products across India. For orders worth ₹300 or more, shipping is absolutely free. If your order total is below ₹300, a flat shipping fee of ₹70 will be applied.</p>
                    </div>
                    
                    <div>
                        <p class="font-medium">Q: Do you support Cash on Delivery (COD)?</p>
                        <p class="mt-1">Yes, Mashhoor Plus proudly supports Cash on Delivery (COD)! We understand the importance of trust and convenience in online shopping. That's why we offer Cash on Delivery on most of our products, so you can shop with confidence and pay only when your order is delivered to your doorstep.</p>
                    </div>
                </div>
            </div>
            
            <div class="bg-gray-50 p-5 rounded-lg">
                <h3 class="text-lg font-semibold mb-2">Returns, Cancellations & Exchanges</h3>
                
                <div class="space-y-4 mt-4">
                    <div>
                        <p class="font-medium">Q: What is your return policy?</p>
                        <p class="mt-1">We believe strongly in our products and their quality and want you to be completely happy with your purchase. If you are disappointed in any way we would like to know. Please see our Returns and Exchange Policy detailed above.</p>
                    </div>
                    
                    <div>
                        <p class="font-medium">Q: How do I cancel an order?</p>
                        <p class="mt-1">
                            <span class="block">Cancellation before shipment: You may cancel your order by going to your Account section and clicking on cancel order.</span>
                            <span class="block mt-1">Cancellation post shipment: Please contact our Customer Care on +91 8273363610 (Timings: 10am-6pm IST) and we will be happy to help you with your order cancellation.</span>
                        </p>
                    </div>
                    
                    <div>
                        <p class="font-medium">Q: How can I receive a refund for my canceled order, and how much time will the process take?</p>
                        <p class="mt-1">Please check our Returns and Exchange Policy to see if your order is eligible for a return. For pre-paid orders that haven't been shipped, cancellations are usually processed within 24 hours, and the refund will follow your bank's refund process, typically taking up to 10 business days. If the order has already been delivered, returns are not accepted unless specified in our policy. For further help, feel free to reach out to our Customer Care at +91 8273363610 (available from 10 AM to 6 PM IST) or email us at <a href="mailto:mashhoorplus&#64;gmail.com" class="text-primary hover:underline">mashhoorplus&#64;gmail.com</a></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Contact Information Section -->
    <section class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Contact Information</h2>
        </div>
        <p>In the rare event that you are not satisfied with the quality of our customer support service, we encourage you to send an email to
             <a href="mailto:mashhoorplus&#64;gmail.com" class="text-primary hover:underline">mashhoorplus&#64;gmail.com</a>. This will allow us to review the issue and address it on a case-by-case basis.</p>
        <p class="mt-2">Alternatively, you can reach our customer care team by calling <span class="font-semibold">+91 8273363610</span> (10am-6pm IST)</p>
    </section>
</div>